import { api } from "..";

export function getProductStatsRequest({ productId, params }) {
  return api.get(`/v1/stats/product/${productId}/tags`, {
    params,
  });
}

export function getStatsActivityOrdersRequest({ params }) {
  return api.get(`/v1/stats/activity/orders`, {
    params,
  });
}

export function getStatsAssetStatusRequest({ params }) {
  return api.get(`/v1/stats/asset/status`, {
    params,
  });
}

export function getStatsAssetCustomerRequest({ params }) {
  return api.get(`/v1/stats/asset/customer`, {
    params,
  });
}

export function getStatsAssetProcessorRequest({ params }) {
  return api.get(`/v1/stats/asset/processor`, {
    params,
  });
}

export function getStatsOrdersOverviewTodayRequest({ params }) {
  return api.get(`/v1/stats/orders/overview/today`, {
    params,
  });
}

export function getStatsOrdersOveriewCurrentRequest({ params }) {
  return api.get(`v1/stats/orders/overview/current`, {
    params,
  });
}

export function getStatsOrdersUnreconciledRequest({ params }) {
  return api.get(`/v1/stats/orders/unreconciled`, {
    params,
  });
}
